import React from 'react';

function JftFinance() {
  return <div>JftFinance</div>;
}

export default JftFinance;
